module.exports = __webpack_public_path__ + "img/d54b73a.png";